/* ============================================================
   INDSO — ingredients-page.js
   Renders the Ingredient Glossary filter chips + card grid from
   a JSON data array, and filters cards by ingredient family.
   ============================================================ */
(function () {
  'use strict';

  const ready = (fn) =>
    document.readyState !== 'loading'
      ? fn()
      : document.addEventListener('DOMContentLoaded', fn);

  ready(() => {
    const root = document.querySelector('[data-glossary]');
    if (!root) return;

    const chipsWrap = root.querySelector('[data-glossary-chips]');
    const grid = root.querySelector('[data-glossary-grid]');
    const emptyEl = root.querySelector('[data-glossary-empty]');

    // Parse data
    let items = [];
    let families = '';
    try {
      const dataEl = document.querySelector('[data-glossary-json]');
      const filtersEl = document.querySelector('[data-glossary-filters]');
      items = JSON.parse(dataEl.textContent) || [];
      families = JSON.parse(filtersEl.textContent) || '';
    } catch (e) { return; }

    const familyList = families
      .split(',')
      .map((f) => f.trim())
      .filter(Boolean);
    const chips = ['All'].concat(familyList);

    let active = 'All';

    function esc(s) {
      const d = document.createElement('div');
      d.textContent = s == null ? '' : s;
      return d.innerHTML;
    }

    function renderChips() {
      chipsWrap.innerHTML = chips
        .map(
          (label) =>
            `<button type="button" class="chip${label === active ? ' chip--active' : ''}" data-chip="${esc(label)}" aria-pressed="${label === active}">${esc(label)}</button>`
        )
        .join('');
    }

    function cardHTML(item) {
      const img = item.image
        ? `<img src="${esc(item.image)}" alt="${esc(item.name)}" loading="lazy" width="600" height="450">`
        : '';
      const tags = item.tags ? `<span class="ingp-card__tags">${esc(item.tags)}</span>` : '';
      const code = item.code ? `<span class="ingp-card__code">${esc(item.code)}</span>` : '';
      return `
        <article class="ingp-card">
          ${item.function_label ? `<div class="ingp-card__fn">${esc(item.function_label)}</div>` : ''}
          ${item.name ? `<h3>${esc(item.name)}</h3>` : ''}
          <div class="ingp-card__swatch">${img}</div>
          ${item.description ? `<p class="ingp-card__desc">${esc(item.description)}</p>` : ''}
          <div class="ingp-card__foot">${code}${tags}</div>
        </article>`;
    }

    function renderGrid() {
      const filtered =
        active === 'All' ? items : items.filter((i) => (i.family || '').trim() === active);
      if (filtered.length === 0) {
        grid.innerHTML = '';
        if (emptyEl) emptyEl.hidden = false;
        return;
      }
      if (emptyEl) emptyEl.hidden = true;
      grid.innerHTML = filtered.map(cardHTML).join('');
    }

    chipsWrap.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-chip]');
      if (!btn) return;
      active = btn.dataset.chip;
      renderChips();
      renderGrid();
    });

    renderChips();
    renderGrid();
  });
})();
